import styles from './style.module.scss';
import { PageHeader } from 'components';
import { Table } from 'antd';
import useShoppingCenter from '../useShoppingCenter';

const CompanyCategoriesMainPage = () => {
  const { columns, data, loading, onChangeTableFilter } =
    useShoppingCenter(true);

  return (
    <div>
      <PageHeader title={'AGENTI'}></PageHeader>
      <div className={styles.container}>
        <Table
          columns={columns}
          dataSource={data.shopping_centers}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
          rowKey='id'
        />
      </div>
    </div>
  );
};

export default CompanyCategoriesMainPage;
